module.exports = __webpack_public_path__ + "img/visa.d73b0d2.svg";